export default "__VITE_ASSET__9c322fc7__"